/**
 * Права текущей сессии для меню, маршрутов и кнопок. В учебном режиме право training.use
 * открывает ровно две учебные команды -- разбор события и сохранение учебной политики
 * доступа (E4.5); остальные права и закрытые разделы остаются как в рабочем контуре.
 */

import { useCallback, useMemo } from 'react';
import type { Permission } from '@/api/workspaceTypes';
import { hasPermission } from '@/auth/permissions';
import { useWorkspaceDataSource } from '@/features/workspace/WorkspaceDataSourceContext';
import { useSessionStore } from '@/stores/session';

const NONE: readonly Permission[] = [];

/** Действия, которые учебный режим выполняет учебными командами */
export const TRAINING_COMMAND_PERMISSIONS: readonly Permission[] = [
	'events.triage',
	'policies.write',
];

export function usePermissions() {
	const session = useSessionStore((s) => s.user?.capabilities ?? NONE);
	const { mode } = useWorkspaceDataSource();
	const capabilities = useMemo(
		() =>
			mode !== 'live' && hasPermission(session, 'training.use')
				? [...new Set([...session, ...TRAINING_COMMAND_PERMISSIONS])]
				: session,
		[mode, session],
	);
	const has = useCallback(
		(permission: Permission) => hasPermission(capabilities, permission),
		[capabilities],
	);
	return { capabilities, has };
}
